import { AiSearchPanelComponent } from '@app/Shared/common-components/td-grid/ai-search-panel/ai-search-panel.component';
import { SettingPanelComponent } from '@app/Shared/common-components/td-grid/setting-panel/setting-panel.component';
import { CheckboxSelectionCallbackParams, GridOptions, ProcessUnpinnedColumnsParams } from 'ag-grid-community';

export function createChildGridOptions(isFirstColumn: (params: CheckboxSelectionCallbackParams) => boolean): GridOptions {
    return {
        columnDefs: [],
        defaultColDef: {
            flex: 1,
            filter: 'agTextColumnFilter',
            sortable: true,
            resizable: true,
            checkboxSelection: isFirstColumn,
        },
        rowSelection: 'single',
        rowMultiSelectWithClick: false,
        suppressNoRowsOverlay: false,
        pagination: true,
        paginationPageSize: 8,
        localeText: { noRowsToShow: 'No children associated to this master' },
    };
}

export function createParentGridOptions(isFirstColumn: (params: CheckboxSelectionCallbackParams) => boolean): GridOptions {
    return {
        columnDefs: [],
        defaultColDef: {
            flex: 1,
            filter: 'agTextColumnFilter',
            sortable: true,
            resizable: true,
            checkboxSelection: isFirstColumn,
        },
        rowSelection: 'single',
        rowMultiSelectWithClick: false,
        suppressNoRowsOverlay: false,
        pagination: true,
        paginationPageSize: 8,
        paginationPageSizeSelector: [8, 30, 50],
        localeText: { noRowsToShow: 'No parent associated to this master' },
    };
}

export function createMasterGridOptions(isFirstColumn: (params: CheckboxSelectionCallbackParams) => boolean): GridOptions {
    return {
        columnDefs: [],
        defaultColDef: {
            floatingFilter: true,
            filter: true,
            sortable: true,
            resizable: true,
            checkboxSelection: isFirstColumn,
            editable: true,
        },
        rowSelection: 'single',
        rowMultiSelectWithClick: false,
        suppressNoRowsOverlay: true,
        pagination: true,
        paginationPageSize: 50,
        paginationPageSizeSelector: [8, 30, 50],
        editType: 'fullRow',
        suppressClickEdit: true,
        processUnpinnedColumns: (params: ProcessUnpinnedColumnsParams) => {
            // Return empty array to prevent any auto-unpinning
            return [];
        },
        sideBar: {
            toolPanels: [
                {
                    id: 'settings',
                    labelDefault: 'Settings',
                    labelKey: 'settings',
                    iconKey: 'filter',
                    toolPanel: SettingPanelComponent,
                    toolPanelParams: {
                        context: {
                            gridId: 'master-grid',
                        },
                    },
                },
                {
                    id: 'aiSearch',
                    labelDefault: 'AI Search',
                    labelKey: 'aiSearch',
                    iconKey: 'search',
                    toolPanel: AiSearchPanelComponent,
                    toolPanelParams: {
                        context: {
                            gridId: 'master-grid',
                        },
                    },
                },
            ],
        },
    };
}

export function createMatchGridOptions(isFirstColumn: (params: CheckboxSelectionCallbackParams) => boolean): GridOptions {
    return {
        columnDefs: [],
        defaultColDef: {
            flex: 1,
            filter: 'agTextColumnFilter',
            sortable: true,
            resizable: true,
            checkboxSelection: isFirstColumn,
        },
        rowSelection: 'single',
        rowMultiSelectWithClick: false,
        suppressNoRowsOverlay: false,
        pagination: true,
        paginationPageSize: 8,
        paginationPageSizeSelector: [8, 30, 50],
        localeText: { noRowsToShow: 'No Match associated to this master' },
    };
}

export function createMergeGridOptions(isFirstColumn: (params: CheckboxSelectionCallbackParams) => boolean): GridOptions {
    return {
        columnDefs: [],
        defaultColDef: {
            cellStyle: { textAlign: 'center' },
            flex: 1,
            filter: 'agTextColumnFilter',
            sortable: true,
            resizable: true,
            checkboxSelection: isFirstColumn,
        },
        rowSelection: 'single',
        rowMultiSelectWithClick: false,
        suppressNoRowsOverlay: false,
        pagination: true,
        paginationPageSize: 8,
        paginationPageSizeSelector: [8, 30, 50],
        localeText: { noRowsToShow: 'No Merge associated to this master' },
    };
}
